import axios from 'axios';
const publicLoansApiClient = axios.create({
    baseURL: process.env.LOANS_API_BASE_URL,
});
export default publicLoansApiClient;
